import { createSelector } from 'reselect';

const getState = (state) => state.salesIntelligence;

const isRecurringOrderSuggestionsModalOpened = createSelector(
  getState,
  (state) => state.ui.suggestionsModalOpened
);

const isRecurringOrderSuggestionsDiscardReasonsModalOpened = createSelector(
  getState,
  (state) => state.ui.suggestionsDiscardReasonsModalOpened
);

const getRecurringOrderSuggestion = createSelector(
  getState,
  (state) => state.recurringOrderSuggestion
);

export default {
  isRecurringOrderSuggestionsModalOpened,
  isRecurringOrderSuggestionsDiscardReasonsModalOpened,
  getRecurringOrderSuggestion,
};
